// extracted by mini-css-extract-plugin
export default {"checkbox":"GJQaxv","checkboxError":"an6F7E"};